import cx from "classnames";
import moment from "moment";
import React from "react";
import styles from "./CalendarDate.scss";

export class CalendarDate extends React.PureComponent {
  render() {
    const { date, large, ...props } = this.props;
    const m = moment(date);
    return (
      <div className={cx(styles.CalendarDate, large && styles.large)} {...props}>
        <div className={styles.heading}>{m.format("ddd")}</div>
        <div className={styles.date}>{m.format("MMM D")}</div>
      </div>
    );
  }
}
